<template>
    <div>
        <rkm-area title="Procedimentos Feridas">
            <rkm-row>
                <rkm-col cols="12">
                    <List
                        :data="data"
                        @edit="$refs.Modal.open($event)"
                        @remove="remove"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <Modal
            :data="modalData"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import List from './List'
import Modal from '../../../../../ferida/components/procedimento/Modal'
import repository from '@/mixins/repository'

export default {
    components: {
        List,
        Modal,
    },
    mixins: [repository],
    created() {
        this.repositories = {
            atendimentoEnfermagem: this.getConectaSusRepository('ambulatorio.atendimentoEnfermagem')
        }
    },
    computed: {
        modalData() {
            return {
                ...this.data,
                soap: { id: this.data.additionals.soapId },
                procedimentos: this.data.model.procedimentosFeridas,
                feridaModel: (this.data.feridaModel && this.data.feridaModel.feridas) ? this.data.feridaModel.feridas : [],
            }
        },
    },
    methods: {
        remove(item) {
            this.showDeleteConfirmation('Deseja realmente excluir o procedimento?', async () => {
                const removeLocal = () => {
                    const flatIndex = this.data.model.procedimentosFeridas.findIndex(p => p === item || (p.id && p.id == item.id))
                    
                    if (flatIndex !== -1) {
                        this.data.model.procedimentosFeridas.splice(flatIndex, 1)
                    }

                    const feridaId = item.ferida_id || item.atendimentoSoapFeridaId || item.feridaId

                    const ferida = this.data.feridaModel && Array.isArray(this.data.feridaModel)
                        ? this.data.feridaModel.find(f => f.id == feridaId)
                        : (this.data.feridaModel && this.data.feridaModel.feridas)
                            ? this.data.feridaModel.feridas.find(f => f.id == feridaId)
                            : null

                    if (ferida && ferida.procedimentos) {
                        const procedimentoIndex = ferida.procedimentos.findIndex(p => {
                            if (item.id) {
                                return p.id == item.id
                            }
                            return p.procedimento.id == item.procedimento.id
                        })

                        if (procedimentoIndex !== -1) {
                            ferida.procedimentos.splice(procedimentoIndex, 1)
                        }
                    }
                }

                if (item.id) {
                    this.repositories.atendimentoEnfermagem.destroyFeridaProcedimento(item.id)
                        .then(() => {
                            removeLocal()
                            this.showSaveNotification('Procedimento excluído com sucesso.')
                        })
                        .catch(error => {
                            const mensagem = error.response?.data?.message || 'Erro ao remover procedimento.'
                            this.showValidationNotification ? 
                                this.showValidationNotification(mensagem) : 
                                this.showAlert(mensagem)
                        })
                } else {
                    removeLocal()
                }
            })
        }
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>
